/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fixture_RemovingInputs */

const th_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังลบ…`)
};

const en_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removing…`)
};

const ja_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除中…`)
};

const zh_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在删除…`)
};

const es_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando…`)
};

const pt_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removendo…`)
};

const id_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghapus…`)
};

const fr_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression…`)
};

const tl_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaalis…`)
};

const vi_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang xoá…`)
};

const ko_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`삭제 중…`)
};

const de_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird entfernt…`)
};

const ru_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаляем…`)
};

const tr_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaldırılıyor…`)
};

const it_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimozione…`)
};

const pl_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuwanie…`)
};

const uk_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видаляємо…`)
};

const hi_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाया जा रहा है…`)
};

const ar_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الحذف…`)
};

const ms_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang membuang…`)
};

const bn_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরানো হচ্ছে…`)
};

const zh_tw2_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除中…`)
};

const zh_hk2_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除中…`)
};

const ur_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ہٹایا جا رہا ہے…`)
};

const fa_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال حذف…`)
};

const sw_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaondolewa…`)
};

const nl_fixture_removing = /** @type {(inputs: Fixture_RemovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met verwijderen…`)
};

/**
* | output |
* | --- |
* | "Removing…" |
*
* @param {Fixture_RemovingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const fixture_removing = /** @type {((inputs?: Fixture_RemovingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fixture_RemovingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_fixture_removing(inputs)
	if (locale === "ja") return ja_fixture_removing(inputs)
	if (locale === "zh") return zh_fixture_removing(inputs)
	if (locale === "es") return es_fixture_removing(inputs)
	if (locale === "pt") return pt_fixture_removing(inputs)
	if (locale === "id") return id_fixture_removing(inputs)
	if (locale === "fr") return fr_fixture_removing(inputs)
	if (locale === "tl") return tl_fixture_removing(inputs)
	if (locale === "vi") return vi_fixture_removing(inputs)
	if (locale === "ko") return ko_fixture_removing(inputs)
	if (locale === "de") return de_fixture_removing(inputs)
	if (locale === "ru") return ru_fixture_removing(inputs)
	if (locale === "tr") return tr_fixture_removing(inputs)
	if (locale === "it") return it_fixture_removing(inputs)
	if (locale === "pl") return pl_fixture_removing(inputs)
	if (locale === "uk") return uk_fixture_removing(inputs)
	if (locale === "hi") return hi_fixture_removing(inputs)
	if (locale === "ar") return ar_fixture_removing(inputs)
	if (locale === "ms") return ms_fixture_removing(inputs)
	if (locale === "bn") return bn_fixture_removing(inputs)
	if (locale === "zh-TW") return zh_tw2_fixture_removing(inputs)
	if (locale === "zh-HK") return zh_hk2_fixture_removing(inputs)
	if (locale === "ur") return ur_fixture_removing(inputs)
	if (locale === "fa") return fa_fixture_removing(inputs)
	if (locale === "sw") return sw_fixture_removing(inputs)
	if (locale === "nl") return nl_fixture_removing(inputs)
	return en_fixture_removing(inputs)
});